import { create } from "zustand";
import { useAuthenticated } from "@/zapi-frontend/shared/hooks/useAuthenticated";

// Tech debt: update typing here
type Me = Partial<ReturnType<typeof useAuthenticated>["me"]> & {
  firstName: string;
  lastName: string;
  role?: string;
  organizationId?: number;
};

type MeState = Me & {
  isLabs?: boolean;
  customSnippetsUrl: string | null;
  refetch?: () => Promise<void>;
  setMe: (data: Partial<Omit<MeState, "setMe">>) => void;
};

export const useMeStore = create<MeState>((set) => ({
  firstName: "",
  lastName: "",
  customSnippetsUrl: null,
  refetch: undefined,
  setMe: (data) => set((state) => ({ ...state, ...data }))
}));
